import React, { useState } from 'react';
import { useAuth } from '../store/AuthContext';
import axios from 'axios';
import { getApiUrl } from '../services/api';
import { User as UserIcon, Shield, Mail, Save, Loader2, Briefcase, Globe, Target } from 'lucide-react';

const ProfilePage = () => {
  const { user, token, setUser } = useAuth();
  const [name, setName] = useState(user?.name || '');
  const [brand, setBrand] = useState(user?.brand || '');
  const [market, setMarket] = useState(user?.market || '');
  const [country, setCountry] = useState(user?.country || 'España');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      const payload = { name, brand, market, country };
      if (password) payload.password = password;

      const resp = await axios.put(`${getApiUrl()}/auth/profile`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // Update local state in AuthContext
      setUser(resp.data.data.user);
      setMessage({ type: 'success', text: 'PERSONNEL FILE UPDATED IN MISSION DATABASE' });
      setPassword('');
    } catch (err) {
      setMessage({ type: 'error', text: err.response?.data?.message || 'FAILED TO UPDATE MISSION PROFILE' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 'clamp(20px, 5vw, 40px)', maxWidth: '600px', margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '40px' }}>
        <div style={{ 
          width: '80px', 
          height: '80px', 
          borderRadius: '50%', 
          backgroundColor: '#0B3D91', 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center',
          border: '2px solid #00CEC9'
        }}>
          <UserIcon size={40} color="white" />
        </div>
        <div>
          <h1 style={{ margin: 0, letterSpacing: '3px', fontSize: '1.5rem', textTransform: 'uppercase' }}>
            Mission Profile
          </h1>
          <p style={{ margin: 0, color: '#E27B58', fontSize: '0.8rem', letterSpacing: '2px' }}>
            ID: {user?.id}
          </p>
        </div>
      </div>

      <div style={{ 
        background: 'rgba(5, 7, 10, 0.9)', 
        border: '1px solid #0B3D91', 
        padding: '30px',
        borderRadius: '4px'
      }}>
        <form onSubmit={handleUpdate}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', color: '#888', fontSize: '0.7rem', marginBottom: '5px', letterSpacing: '1px' }}>
              DESIGNATED NAME
            </label>
            <div style={{ position: 'relative' }}>
              <UserIcon size={16} color="#0B3D91" style={{ position: 'absolute', left: '12px', top: '10px' }} />
              <input
                className="nasa-input"
                style={{ paddingLeft: '40px' }}
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="MISSION COMMANDER"
                required
              />
            </div>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', color: '#888', fontSize: '0.7rem', marginBottom: '5px', letterSpacing: '1px' }}>
              COMMUNICATION CHANNEL (EMAIL)
            </label>
            <div style={{ position: 'relative' }}>
              <Mail size={16} color="#0B3D91" style={{ position: 'absolute', left: '12px', top: '10px' }} />
              <input
                className="nasa-input"
                style={{ paddingLeft: '40px', opacity: 0.6 }}
                value={user?.email || ''}
                disabled
              />
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px' }}>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', color: '#888', fontSize: '0.7rem', marginBottom: '5px', letterSpacing: '1px' }}>
                COMPANY / BRAND
              </label>
              <div style={{ position: 'relative' }}>
                <Briefcase size={16} color="#0B3D91" style={{ position: 'absolute', left: '12px', top: '10px' }} />
                <input
                  className="nasa-input"
                  style={{ paddingLeft: '40px' }}
                  value={brand}
                  onChange={(e) => setBrand(e.target.value)}
                  placeholder="ACME CORP"
                />
              </div>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', color: '#888', fontSize: '0.7rem', marginBottom: '5px', letterSpacing: '1px' }}>
                SECTOR / MARKET
              </label>
              <div style={{ position: 'relative' }}>
                <Target size={16} color="#0B3D91" style={{ position: 'absolute', left: '12px', top: '10px' }} />
                <input
                  className="nasa-input"
                  style={{ paddingLeft: '40px' }}
                  value={market}
                  onChange={(e) => setMarket(e.target.value)}
                  placeholder="RETAIL"
                />
              </div>
            </div>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', color: '#888', fontSize: '0.7rem', marginBottom: '5px', letterSpacing: '1px' }}>
              OPERATIONAL COUNTRY (DEFAULT)
            </label>
            <div style={{ position: 'relative' }}>
              <Globe size={16} color="#0B3D91" style={{ position: 'absolute', left: '12px', top: '10px' }} />
              <input
                className="nasa-input"
                style={{ paddingLeft: '40px' }}
                value={country}
                onChange={(e) => setCountry(e.target.value)}
                placeholder="España"
              />
            </div>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', color: '#888', fontSize: '0.7rem', marginBottom: '5px', letterSpacing: '1px' }}>
              NEW ACCESS KEY (PASSWORD)
            </label>
            <input
              type="password"
              className="nasa-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="LEAVE BLANK TO KEEP CURRENT KEY"
            />
          </div>

          <div style={{ marginBottom: '30px' }}>
            <label style={{ display: 'block', color: '#888', fontSize: '0.7rem', marginBottom: '5px', letterSpacing: '1px' }}>
              SYSTEM ROLE
            </label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#00CEC9' }}>
              <Shield size={16} />
              <span style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>{user?.role?.toUpperCase()}</span>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="nasa-button"
            style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}
          >
            {loading ? <Loader2 className="animate-spin" size={18} /> : <Save size={18} />}
            {loading ? 'UPLOADING DATA...' : 'SAVE PROFILE CHANGES'}
          </button>
        </form>

        {message && (
          <div style={{
            marginTop: '20px',
            padding: '12px',
            fontSize: '0.8rem',
            backgroundColor: message.type === 'success' ? 'rgba(0, 184, 148, 0.1)' : 'rgba(214, 48, 49, 0.1)',
            color: message.type === 'success' ? '#00B894' : '#D63031',
            border: `1px solid ${message.type === 'success' ? '#00B894' : '#D63031'}`,
            textAlign: 'center'
          }}>
            {message.text}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfilePage;
